// src/components/admin/flows/components/WorkflowFilters.js
import React from 'react';
import { Search, Filter } from 'lucide-react';
import { useTheme } from '../../../../contexts/ThemeContext';

const WORKFLOW_TYPES = [
    { value: '', label: 'All Types' },
    { value: 'onboarding', label: 'Onboarding' },
    { value: 'offboarding', label: 'Offboarding' },
    { value: 'approval_chain', label: 'Approval Chain' },
    { value: 'task_automation', label: 'Task Automation' },
    { value: 'custom', label: 'Custom' },
];

const WORKFLOW_STATUSES = [
    { value: '', label: 'All Statuses' },
    { value: 'draft', label: 'Draft' },
    { value: 'active', label: 'Active' },
    { value: 'paused', label: 'Paused' },
    { value: 'archived', label: 'Archived' },
];

const WorkflowFilters = ({ filters, onFilterChange }) => {
    const { theme } = useTheme();
    const isDark = theme === 'dark';

    const inputClass = `px-3 py-2 rounded-lg text-sm border ${
        isDark
            ? 'bg-gray-800 border-gray-600 text-white placeholder-gray-400'
            : 'bg-white border-gray-300 text-gray-900 placeholder-gray-400'
    } focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent`;

    return (
        <div className="flex flex-wrap items-center gap-3">
            <div className="relative flex-1 min-w-[200px]">
                <Search className={`absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 ${isDark ? 'text-gray-400' : 'text-gray-400'}`} />
                <input
                    type="text"
                    placeholder="Search workflows..."
                    value={filters.search || ''}
                    onChange={(e) => onFilterChange({ ...filters, search: e.target.value })}
                    className={`${inputClass} pl-9 w-full`}
                />
            </div>

            <select
                value={filters.type || ''}
                onChange={(e) => onFilterChange({ ...filters, type: e.target.value })}
                className={inputClass}
            >
                {WORKFLOW_TYPES.map(t => (
                    <option key={t.value} value={t.value}>{t.label}</option>
                ))}
            </select>

            <select
                value={filters.status || ''}
                onChange={(e) => onFilterChange({ ...filters, status: e.target.value })}
                className={inputClass}
            >
                {WORKFLOW_STATUSES.map(s => (
                    <option key={s.value} value={s.value}>{s.label}</option>
                ))}
            </select>
        </div>
    );
};

export default WorkflowFilters;
